import React from 'react';
import { useParams } from 'react-router-dom';

import PrivatePage from 'components/PrivatePage';
import { default as SerieComponent } from 'components/Serie';

const Serie = ({navbarProps}) => {
  const { id } = useParams();
  return (
    <PrivatePage navbarProps={navbarProps}>
      <SerieComponent id={id}/>
    </PrivatePage>
  )
}

export default Serie;